import { render, staticRenderFns } from "./RejectionReasonEditForm.vue?vue&type=template&id=c3206810&scoped=true&"
import script from "./RejectionReasonEditForm.vue?vue&type=script&lang=ts&"
export * from "./RejectionReasonEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionReasonEditForm.vue?vue&type=style&index=0&id=c3206810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3206810",
  null
  
)

export default component.exports